import React from 'react';
import { NavLink, Route, Switch } from 'react-router-dom';

import AdminSubHeader from '../../layouts/partials/AdminSubheader';
import FrequentPassageRequestsListView from '../../shared/frequentPassageRequests/FrequentPassageRequestsListView';
import ParkingStickersVouchersScan from '../parkingStickers/ParkingStickersVouchersScan';
import ParkingStickersVouchersSearch from '../parkingStickers/ParkingStickersVouchersSearch';
import FrequentPassageManualSearch from './components/FrequentPassageManualSearch';
import FrequentPassageVoucherSearch from './components/FrequentPassageVoucherSearch';

export default function FrequentPassageStickerHandout() {
  return (
    <>
      <div className="m-content">
        <div className="row justify-content-center">
          <div className="col-lg-9 col-xl-7">
            <div className="m-portlet m-portlet--tabs">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <h3 className="m-portlet__head-text">Frequent Passage Desk</h3>
                  </div>
                </div>
                <div className="m-portlet__head-tools">
                  <ul
                    className="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand  m-tabs-line--right m-tabs-line-danger"
                    role="tablist"
                  >
                    <li className="nav-item m-tabs__item">
                      <NavLink
                        exact
                        className="nav-link m-tabs__link"
                        to={'/admin/frequent-passage-stickers/voucher-search'}
                      >
                        <i className="flaticon-interface" />
                        Voucher
                      </NavLink>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <NavLink
                        exact
                        className="nav-link m-tabs__link"
                        to={'/admin/frequent-passage-stickers/manual-search'}
                      >
                        <i className="flaticon-search-magnifier-interface-symbol" />
                        Manual Search
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>
              <Switch>
                <Route
                  exact
                  path="/admin/frequent-passage-stickers/voucher-search"
                  component={FrequentPassageVoucherSearch}
                />
                <Route
                  exact
                  path="/admin/frequent-passage-stickers/manual-search"
                  component={FrequentPassageManualSearch}
                />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
